import React, {useEffect, useState} from "react";
import {getItemsState} from "../../util/functions";
import {validStateChecked} from "../Switch";


const CheckBox = ({identificador, label, onChange, value = "", styleLabel = {}, styleCheck = {}, disabled= false}) => {

  const [state, setState] = useState(value);

  const onChangeEvent = ({target:{name, checked}}) => {
        setState(checked);
        onChange({name, checked, label});
  }

  useEffect(() => {
    setState(value);
  }, [value])

  return(
        <>
          <input onChange={onChangeEvent} className="form-check-input" style={styleCheck} type="checkbox" disabled={disabled} checked={validStateChecked(state)} value={state} id={identificador} name={identificador}/>
          <label className="form-check-label no-space-break" style={styleLabel} htmlFor={identificador}>
            {label}
          </label>
        </>
  )

}


export default React.memo(CheckBox);
